import { Store } from '@ngrx/store';
import { StorageService } from './shared/services/storage/storage.service';
import { Component } from '@angular/core';
import { ListLoggedInPartnerCompany } from './store/crimp-cloud-partners/crimp-cloud-partners.actions';
import { appConstants } from './shared/constants/app.constants';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(
    private storage: StorageService,
    private readonly store: Store<[]>,
  ) { }

  ngOnInit() {
    const cachedUser = this.storage.get(appConstants.PARTNER_ID);
    if (cachedUser) {
      this.store.dispatch(
        new ListLoggedInPartnerCompany({ partnerId: cachedUser })
      );
    }
  }
}
